import clsx from 'clsx';
import React from 'react';
import { UiFlex, UiFlexProps } from '@open-stack/ui';
import styled from 'styled-components';

const Wrapper = styled(UiFlex)`
    border-radius: 40px;
    box-shadow: 0 0 0 1px var(--x-color-divider);

    &,
    .XButton {
        height: var(--XButton-height);
    }

    .XButton {
        border: 1px solid transparent !important;
        border-radius: 40px;
    }
`;

interface Props extends UiFlexProps {
    children: any;
}

export function ButtonGroup(props: Props) {
    return <Wrapper flexChildren overflowAuto fullWidth {...props} className={clsx(props.className, 'ButtonGroup')} />;
}
